import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import shallowEqual from '../utils/shallowEqual';
import { compose } from '../utils/func';
import { scrollConsumer } from '../Scroll/context';
import { listClass } from './styles';
import { docSize } from '../utils/dom/document';
import { getRTLPosition } from '../utils/strings';
import zIndexConsumer from '../Modal/context';
import { isRTL, getDefaultContainer } from '../config';
import { addZoomListener, removeZoomListener } from '../utils/zoom';
import { isInDocument } from '../utils/dom/isInDocument';
var PICKER_V_MARGIN = 4;
var root;

function initRoot(element) {
  var defaultContainer = getDefaultContainer();
  root = document.createElement('div');
  root.className = listClass('root', isRTL() && 'rtl');
  defaultContainer.appendChild(root);

  if (element && isInDocument(element) === false) {
    root.appendChild(element);
  }
}

function getRoot(element) {
  if (!root || isInDocument(root) === false) initRoot(element);

  if (element && isInDocument(element) === false) {
    root.appendChild(element);
  }

  return root;
}

var getOverDocStyle = function getOverDocStyle(right) {
  return right ? {
    left: 0,
    right: 'auto'
  } : {
    right: 0,
    left: 'auto'
  };
};

var listPosition = ['drop-down', 'drop-up'];
var pickerPosition = ['left-bottom', 'left-top', 'right-bottom', 'right-top'];
var dropdownPosition = ['bottom-left', 'bottom-right', 'top-left', 'top-right'];
export default function (List) {
  var AbsoluteList =
  /*#__PURE__*/
  function (_Component) {
    _inherits(AbsoluteList, _Component);

    var _super = _createSuper2(AbsoluteList);

    function AbsoluteList(props) {
      var _this;

      _classCallCheck(this, AbsoluteList);

      _this = _super.call(this, props);
      _this.state = {
        overdoc: false
      };
      _this.lastStyle = void 0;
      _this.container = void 0;
      _this.element = void 0;
      _this.ajustdoc = void 0;
      _this.containerRect = void 0;
      _this.containerScroll = void 0;
      _this.el = void 0;
      _this.handleRef = _this.handleRef.bind(_assertThisInitialized(_this));
      if (!props.absolute) return _possibleConstructorReturn(_this);
      _this.lastStyle = {};
      if (!root) initRoot();
      _this.container = _this.getContainer();
      _this.element = document.createElement('div');
      if (_this.container) _this.container.appendChild(_this.element);

      if (props.getResetPosition) {
        props.getResetPosition(_this.resetPosition.bind(_assertThisInitialized(_this)));
      }

      _this.zoomChangeHandler = _this.zoomChangeHandler.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(AbsoluteList, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (this.props.absolute && !this.container) {
          this.container = this.getContainer();
          this.container.appendChild(this.element);

          if (this.props.focus) {
            this.forceUpdate();
          }
        }

        if (this.props.absolute) {
          addZoomListener(this.zoomChangeHandler);
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var _this2 = this;

        if (!this.props.focus) this.ajustdoc = false;
        if (shallowEqual(prevProps.value, this.props.value)) return;
        setTimeout(function () {
          _this2.forceUpdate();
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        var absolute = this.props.absolute;
        if (!absolute) return;
        removeZoomListener(this.zoomChangeHandler);

        if (this.container) {
          if (this.element && this.element.parentNode) this.element.parentNode.removeChild(this.element);
        }
      }
    }, {
      key: "getContainer",
      value: function getContainer(element) {
        return typeof this.props.absolute === 'function' ? this.props.absolute() : getRoot(element);
      }
    }, {
      key: "getPosition",
      value: function getPosition(rect) {
        var fixed = this.props.fixed;
        var _ref = this.props,
            position = _ref.position;
        var rtl = isRTL();
        var style = {
          position: 'absolute',
          right: 'auto'
        };

        if (fixed) {
          var widthKey = fixed === 'min' ? 'minWidth' : 'width';
          style[widthKey] = rect.width;
        }

        if (dropdownPosition.includes(position)) {
          position = position.split('-').reverse().join('-');
        }

        if (rtl) {
          position = getRTLPosition(position);
        }

        var container = this.getContainer(this.element);
        var defaultContainer = getDefaultContainer();
        var rootContainer = container === getRoot() || !container ? defaultContainer : container;
        var containerRect = rootContainer.getBoundingClientRect();
        var containerScroll = {
          left: rootContainer.scrollLeft,
          top: rootContainer.scrollTop
        };
        this.containerRect = containerRect;
        this.containerScroll = containerScroll;

        if (listPosition.includes(position)) {
          style.left = rect.left - containerRect.left + containerScroll.left;

          if (isRTL()) {
            style.right = containerRect.width - rect.width - style.left;
            style.left = 'auto';
          }

          if (position === 'drop-down') {
            style.top = rect.top - containerRect.top + rect.height + containerScroll.top;
          } else {
            style.bottom = -(rect.top - containerRect.top + containerScroll.top);
          }
        } else if (pickerPosition.includes(position)) {
          var _position$split = position.split('-'),
              _position$split2 = _slicedToArray(_position$split, 2),
              h = _position$split2[0],
              v = _position$split2[1];

          if (h === 'left') {
            style.left = rect.left - containerRect.left + containerScroll.left;
          } else {
            style.right = containerRect.width - rect.width - rect.left + containerRect.left - containerScroll.left;
            style.left = 'auto';
          }

          if (v === 'bottom') {
            style.top = rect.bottom - containerRect.top + containerScroll.top + PICKER_V_MARGIN;
          } else {
            style.top = rect.top - containerRect.top + containerScroll.top - PICKER_V_MARGIN;
            style.transform = 'translateY(-100%)';
          }
        }

        return style;
      }
    }, {
      key: "getStyle",
      value: function getStyle() {
        var _this$props = this.props,
            parentElement = _this$props.parentElement,
            scrollElement = _this$props.scrollElement,
            focus = _this$props.focus;
        var lazyResult = {
          focus: focus,
          style: this.lastStyle
        };
        if (!focus) return lazyResult;
        var style = {};

        if (parentElement) {
          var rect = parentElement.getBoundingClientRect();
          var scrollRect = scrollElement ? scrollElement.getBoundingClientRect() : {};

          if (rect.bottom < scrollRect.top || rect.top > scrollRect.bottom || rect.right < scrollRect.left || rect.left > scrollRect.right) {
            return {
              focus: false,
              style: this.lastStyle
            };
          }

          style = this.getPosition(rect);
        }

        if (shallowEqual(style, this.lastStyle)) return lazyResult;
        this.lastStyle = style;
        return {
          focus: focus,
          style: style
        };
      }
    }, {
      key: "zoomChangeHandler",
      value: function zoomChangeHandler() {
        if (this.props.focus) {
          this.forceUpdate();
        }
      }
    }, {
      key: "isRight",
      value: function isRight() {
        var position = this.props.position;
        var isRight = false;

        if (position && position.indexOf('right') > 1) {
          isRight = true;
        }

        if (isRTL()) {
          isRight = !isRight;
        }

        return isRight;
      }
    }, {
      key: "resetPosition",
      value: function resetPosition(clean) {
        var _this$props2 = this.props,
            focus = _this$props2.focus,
            parentElement = _this$props2.parentElement;
        if (!this.el || !focus || this.ajustdoc && !clean) return;
        var width = this.el.offsetWidth;
        var pos = parentElement && parentElement.getBoundingClientRect() || {
          left: 0,
          right: 0
        };
        var containerRect = this.containerRect || {
          left: 0,
          width: 0
        };
        var containerScroll = this.containerScroll || {
          left: 0
        };
        var overdoc;

        if (this.isRight()) {
          if (isRTL() && containerScroll.left) {
            // this condition  the style left: 0 will not meet expect so not set overdoc
            overdoc = false;
          } else {
            overdoc = pos.right - width < containerRect.left;
          }
        } else if (!isRTL() && containerScroll.left) {
          // this condition  the style right: 0 will not meet expect so not set overdoc
          overdoc = false;
        } else {
          overdoc = pos.left - containerRect.left + width + containerScroll.left > (containerRect.width || docSize.width);
        }

        if (this.state.overdoc === overdoc) return;
        this.ajustdoc = true;
        this.setState({
          overdoc: overdoc
        });
      }
    }, {
      key: "handleRef",
      value: function handleRef(ref) {
        this.el = ref;
      }
    }, {
      key: "renderList",
      value: function renderList() {
        var _this$props3 = this.props,
            parentElement = _this$props3.parentElement,
            absolute = _this$props3.absolute,
            focus = _this$props3.focus,
            rootClass = _this$props3.rootClass,
            position = _this$props3.position,
            scrollLeft = _this$props3.scrollLeft,
            scrollTop = _this$props3.scrollTop,
            scrollElement = _this$props3.scrollElement,
            _this$props3$style = _this$props3.style,
            style = _this$props3$style === void 0 ? {} : _this$props3$style,
            zIndex = _this$props3.zIndex,
            getResetPosition = _this$props3.getResetPosition,
            ignore = _this$props3.autoAdapt,
            props = _objectWithoutProperties(_this$props3, ["parentElement", "absolute", "focus", "rootClass", "position", "scrollLeft", "scrollTop", "scrollElement", "style", "zIndex", "getResetPosition", "autoAdapt"]);

        if (zIndex !== undefined) {
          var parsed = parseInt(zIndex, 10);
          if (!Number.isNaN(parsed)) style.zIndex = parsed;
        }

        var mergeStyle = Object.assign({}, style, this.state.overdoc ? getOverDocStyle(this.isRight()) : undefined);
        return (
          /*#__PURE__*/
          React.createElement(List, Object.assign({
            getRef: this.handleRef
          }, props, {
            focus: focus,
            style: mergeStyle
          }))
        );
      }
    }, {
      key: "render",
      value: function render() {
        var _this3 = this;

        var autoAdapt = this.props.autoAdapt;
        setTimeout(function () {
          _this3.resetPosition(autoAdapt);
        });

        if (!this.props.absolute) {
          return this.renderList();
        }

        if (!this.container) return null;

        var _this$props4 = this.props,
            parentElement = _this$props4.parentElement,
            rootClass = _this$props4.rootClass,
            absolute = _this$props4.absolute,
            position = _this$props4.position,
            scrollLeft = _this$props4.scrollLeft,
            scrollTop = _this$props4.scrollTop,
            scrollElement = _this$props4.scrollElement,
            autoClass = _this$props4.autoClass,
            zIndex = _this$props4.zIndex,
            getResetPosition = _this$props4.getResetPosition,
            value = _this$props4.value,
            ignore = _this$props4.autoAdapt,
            props = _objectWithoutProperties(_this$props4, ["parentElement", "rootClass", "absolute", "position", "scrollLeft", "scrollTop", "scrollElement", "autoClass", "zIndex", "getResetPosition", "value", "autoAdapt"]);

        var mergeClass = classnames(listClass('absolute-wrapper'), rootClass, autoClass);

        var _ref2 = props.focus ? this.getStyle() : {
          style: this.lastStyle,
          focus: undefined
        },
            focus = _ref2.focus,
            style = _ref2.style;

        this.element.className = mergeClass;
        var mergeStyle = Object.assign({}, style, props.style, this.state.overdoc ? getOverDocStyle(this.isRight()) : undefined);
        if (zIndex || typeof zIndex === 'number') mergeStyle.zIndex = parseInt(zIndex, 10);
        return (
          /*#__PURE__*/
          ReactDOM.createPortal(
          /*#__PURE__*/
          React.createElement(List, Object.assign({
            getRef: this.handleRef
          }, props, {
            focus: focus,
            style: mergeStyle,
            autoAdapt: autoAdapt,
            resetPosition: this.resetPosition.bind(this)
          })), this.element)
        );
      }
    }]);

    return AbsoluteList;
  }(Component);

  return compose(scrollConsumer, zIndexConsumer)(AbsoluteList);
}